module.exports = __webpack_public_path__ + "img/banner.c4870ffb.png";